export default __webpack_public_path__ + "static/media/card3.f7f555cd.png";